import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Registers from "./Registers";
import Shifts from "./Shifts";
import RegisterControlPanel from "./RegisterControlPanel";
import { Calculator, DoorClosed, Gauge } from "lucide-react";

// Kasalar (tanım) + Z Raporları/Vardiyalar tek modülde birleştirildi.
export default function CashCenter() {
  const { can } = useAuth();
  const canManage = can("register.manage") || can("user.assign") || can("location.manage") || can("user.manage");
  const canReport = can("report.read");
  const [sp, setSp] = useSearchParams();

  const tabs = [];
  if (canReport) tabs.push(["panel", "Kontrol Paneli", Gauge]);
  if (canManage) tabs.push(["kasalar", "Kasalar", Calculator]);
  if (canReport) tabs.push(["z", "Z Raporları / Vardiyalar", DoorClosed]);

  const wanted = ["z", "panel"].includes(sp.get("tab")) ? sp.get("tab") : (canManage ? "kasalar" : "panel");
  const [tab, setTab] = useState(wanted);
  const active = tabs.some((t) => t[0] === tab) ? tab : tabs[0]?.[0];

  return (
    <div className="mx-auto max-w-7xl" data-testid="cash-center-page">
      {tabs.length > 1 && (
        <div className="px-4 pt-4 sm:px-6">
          <div className="mb-1 inline-flex rounded-xl border border-slate-200 bg-slate-50 p-1" data-testid="cash-center-tabs">
            {tabs.map(([k, lbl, Icon]) => (
              <button key={k} data-testid={`cash-tab-${k}`}
                onClick={() => { setTab(k); setSp(k === "kasalar" ? {} : { tab: k }, { replace: true }); }}
                className={`inline-flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-bold transition-colors ${active === k ? "bg-white text-brand-green shadow-sm ring-1 ring-slate-200" : "text-slate-500 hover:text-slate-700"}`}>
                <Icon className="h-4 w-4" /> {lbl}
              </button>
            ))}
          </div>
        </div>
      )}
      <div className={tabs.length > 1 ? "px-0" : ""}>
        {active === "kasalar" ? <Registers /> : active === "panel" ? <RegisterControlPanel /> : <Shifts />}
      </div>
    </div>
  );
}
